import { useCallback, useEffect, useRef, useState } from 'react';
import { vencimientosApi } from './api';

/* Limpia params vacios para no mandar query strings inutiles. */
function cleanParams(filtros = {}) {
  const out = {};
  Object.entries(filtros).forEach(([k, v]) => {
    if (v === '' || v === null || v === undefined || v === 'todos') return;
    out[k] = v;
  });
  return out;
}

export function useVencimientos(filtros = {}) {
  const [data, setData] = useState([]);
  const [kpis, setKpis] = useState(null);
  const [aseguradoras, setAseguradoras] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Serializamos los filtros para el dependency array (objeto nuevo cada render).
  const key = JSON.stringify(filtros);
  const abortRef = useRef(null);

  // Cancela la peticion anterior en vuelo antes de lanzar otra: si el usuario
  // sigue escribiendo/cambiando filtros, la respuesta vieja se aborta y NO pisa
  // la nueva (evita resultados que "saltan" por respuestas fuera de orden).
  const refresh = useCallback(async () => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;

    setLoading(true);
    setError(null);
    try {
      const res = await vencimientosApi.getVencimientos(cleanParams(JSON.parse(key)), ctrl.signal);
      if (ctrl.signal.aborted) return;
      const body = res?.data;
      if (body?.status) {
        setData(body.data || []);
        setKpis(body.kpis || null);
        setAseguradoras(body.aseguradoras || []);
        setPagination(body.pagination || null);
      }
    } catch (e) {
      // Peticion cancelada (llego otra): se ignora, no es un error real.
      if (ctrl.signal.aborted || e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') return;
      setError(e);
    } finally {
      if (!ctrl.signal.aborted) setLoading(false);
    }
  }, [key]);

  useEffect(() => {
    refresh();
    // Al cambiar filtros o desmontar, aborta la peticion en vuelo.
    return () => {
      if (abortRef.current) abortRef.current.abort();
    };
  }, [refresh]);

  return { data, kpis, aseguradoras, pagination, loading, error, refresh };
}

export function useClienteDetalle(userId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await vencimientosApi.getCliente(userId);
      const body = res?.data;
      if (body?.status) {
        setData(body.data || null);
      }
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, loading, error, refresh };
}
